import classNames from 'classnames';
import React, { ReactNode } from 'react';
import Box, { BoxProps } from 'ui-box';
import { Icon, majorScale, minorScale } from '.';

export type ICheckboxProps = {
  label?: string | ReactNode;
  labelDirection?: 'left' | 'right';
  onChange?: (flag: boolean) => void;
  small?: boolean;
  disabled?: boolean;
} & Omit<BoxProps<'input'>, 'onChange'>;

export const Checkbox: React.FC<ICheckboxProps> = ({
  label,
  labelDirection = 'right',
  value,
  checked = false,
  onChange,
  name,
  small = false,
  disabled = false,
  ...props
}) => {
  const [innerValue, setInnerValue] = React.useState(!!value || checked);
  const [changed, setChanged] = React.useState(false);
  React.useEffect(() => {
    setInnerValue(!!value || checked);
  }, [value, checked]);

  React.useEffect(() => {
    if (changed) onChange && onChange(innerValue);
    setChanged(false);
  }, [changed, innerValue, onChange]);

  return (
    <Box
      is="label"
      className={classNames(
        'checkbox',
        small && 'small',
        disabled && 'disabled'
      )}
      marginTop={majorScale(1)}
      marginBottom={minorScale(2)}
      {...props}
    >
      {!!label && labelDirection === 'left' && <span>{label}</span>}
      <Box position="relative">
        <Box
          name={name}
          is="input"
          disabled={disabled}
          type="checkbox"
          checked={innerValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setChanged(true);
            setInnerValue(e.target.checked);
          }}
        />
        <Icon className="tick" icon="small-tick" size={15} color="#ffffff" />
      </Box>
      {!!label && labelDirection === 'right' && <span>{label}</span>}
    </Box>
  );
};
